module.exports = __webpack_public_path__ + "static/media/ClassdefinitionOverview.2e751ade.md";